<p-columnFilter matchMode="equals" showClearButton="false" showMatchModes="false" type="date" [field]="field"
  showMenu="false">
  <ng-template pTemplate="filter">
    <p-datepicker [formControl]="control" selectionMode="range" [dateFormat]="'dd/mm/yy'" showIcon iconDisplay="input"
      size="small" placeholder="Rango fecha" (onSelect)="filterInput($event)" appendTo="body" />
  </ng-template>
</p-columnFilter>